import type { ProductsTab } from '../../types';
import { FBXViewer } from './FBXViewer';

type Vec3 = [number, number, number];

interface ModelConfig {
	url: string;
	cameraZ: number;
	scale: number;
	modelPosition: Vec3;
	labelPosition: Vec3;
}

const MODEL_CONFIG: Record<string, ModelConfig> = {
	defensives_liquid: {
		url: '/3d/bottle.fbx',
		cameraZ: 17,
		scale: 0.023,
		modelPosition: [0, 0.5, 0],
		labelPosition: [0, -1.1, 2.7],
	},
	defensives_solid: {
		url: '/3d/bag.fbx',
		cameraZ: 14.5,
		scale: 0.023,
		modelPosition: [0, 0, 0],
		labelPosition: [0, -0.1, 2.5],
	},
	fertilizers_liquid: {
		url: '/3d/galon.fbx',
		cameraZ: 9,
		scale: 0.023,
		modelPosition: [0, 0.2, 0],
		labelPosition: [0, -0.9, -0.6],
	},
	fertilizers_solid: {
		url: '/3d/box.fbx',
		cameraZ: 11.7,
		scale: 0.03,
		modelPosition: [0, -1, 0],
		labelPosition: [0.02, -1.1, 1.5],
	},
	default: {
		url: '/3d/bottle.fbx',
		cameraZ: 17,
		scale: 0.023,
		modelPosition: [0, 0.4, 0],
		labelPosition: [0, -1.1, 2.7],
	},
};

function normalizeNature(nature: string): 'liquid' | 'solid' | null {
	const n = nature?.toLowerCase().trim();
	if (n === 'liquid' || n === 'líquido' || n === 'liquido') return 'liquid';
	if (n === 'solid' || n === 'sólido' || n === 'solido') return 'solid';
	return null;
}

function getConfigKey(type: ProductsTab, nature: string): string {
	if (type === 'manufacturers') return 'default';
	const normalized = normalizeNature(nature);
	if (normalized) return `${type}_${normalized}`;
	return 'default';
}

interface ProductModelProps {
	type: ProductsTab;
	nature: string;
	name: string;
	manufacturer?: string;
	extra?: string;
}

export const ProductModel = ({ type, nature, name, manufacturer, extra }: ProductModelProps) => {
	const configKey = getConfigKey(type, nature);
	const config = MODEL_CONFIG[configKey] ?? MODEL_CONFIG.default;

	return (
		<div style={{ width: '100%', height: '100%' }}>
			<FBXViewer
				key={configKey}
				url={config.url}
				cameraZ={config.cameraZ}
				scale={config.scale}
				modelPosition={config.modelPosition}
				labelPosition={config.labelPosition}
				title={name}
				manufacturer={manufacturer}
				subtitle={extra}
				responsiveMultiplier={1.2}
				labelMultiplier={1.3}
			/>
		</div>
	);
};
